<template>
  <span
    :style="wrapperStyle"
    :title="value"
    @click="onClick"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <span :style="valueStyle">{{ display }}</span>
    <button
      v-if="copyable"
      type="button"
      :title="copied ? '복사됨' : '복사'"
      :style="copyBtnStyle"
      @click.stop="copy"
      @mouseenter.stop="copyHover = true"
      @mouseleave.stop="copyHover = false"
    >
      <i :class="copied ? 'el-icon-check' : 'el-icon-document-copy'" style="font-size:12px;"></i>
    </button>
  </span>
</template>

<script>
export default {
  name: 'IdMono',
  props: {
    value: { type: String, default: '' },
    truncate: { type: Number, default: 0 },
    copyable: { type: Boolean, default: true },
  },
  data() {
    return { copied: false, hovering: false, copyHover: false }
  },
  computed: {
    clickable() {
      return !!this.$listeners.click
    },
    display() {
      if (!this.value) return ''
      if (this.truncate > 0 && this.value.length > this.truncate) {
        const head = Math.ceil((this.truncate - 1) / 2)
        const tail = Math.floor((this.truncate - 1) / 2)
        return `${this.value.slice(0, head)}…${this.value.slice(-tail)}`
      }
      return this.value
    },
    wrapperStyle() {
      return {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontFamily: "ui-monospace,'SF Mono',Menlo,Consolas,monospace",
        fontSize: '13px',
        color: 'inherit',
        cursor: this.clickable ? 'pointer' : 'inherit',
      }
    },
    valueStyle() {
      const style = { whiteSpace: 'nowrap' }
      if (this.clickable) {
        style.borderBottom = '1px dashed rgba(115,103,240,0.4)'
        if (this.hovering) {
          style.color = '#7367F0'
          style.borderBottomColor = 'rgba(115,103,240,0.7)'
        }
      }
      return style
    },
    copyBtnStyle() {
      return {
        background: 'transparent',
        border: '0',
        color: 'inherit',
        cursor: 'pointer',
        padding: '2px',
        borderRadius: '3px',
        opacity: this.copyHover ? '0.8' : '0.4',
        transition: 'opacity 120ms ease',
      }
    },
  },
  methods: {
    onClick() {
      this.$emit('click', this.value)
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.value)
        this.copied = true
        setTimeout(() => (this.copied = false), 1500)
      } catch (e) {
        /* clipboard not available; silently ignore */
      }
    },
  },
}
</script>
